export const incrementAndMaintainNumberPadding = {
  methods: {
    incrementAndMaintainNumberPadding (currentNumber) {
      // like extreme sports, people who make invoice numbers like to have padding.
      // this function takes their String number with padded zeros, increases it by one then maintains the original padding.
      // get the length of the current string, we'll need that in a bit
      const stringLength = currentNumber.length
      // increase the number by one
      currentNumber++
      // now return the new number as a string padded with zero's to it's original length
      return currentNumber.toString().padStart(stringLength, '0')
    }
  }
}
